import React from 'react';
import { Table, Badge, Typography } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;

const QueueMonitoringTable = ({ calls, timers }) => {
    const columns = [
        {
            title: 'Hora',
            dataIndex: 'call_start',
            key: 'hour',
            width: 90,
            render: (text) => dayjs(text).format('HH:mm:ss'),
        },
        {
            title: 'Origen',
            dataIndex: 'source',
            key: 'source',
            render: (text) => <Text style={{ fontSize: '13px' }}>{text}</Text>
        },
        {
            title: 'DID',
            dataIndex: 'did',
            key: 'did',
            render: (text) => <Text type="secondary" style={{ fontSize: '12px' }}>{text || '-'}</Text>
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            render: (status, record) => {
                const isQueue = status === 'in_queue';
                return (
                    <Badge
                        status={isQueue ? 'warning' : 'processing'}
                        text={isQueue ? 'En Cola' : `Activa (${record.agent_name || 'Agente'})`}
                    />
                );
            }
        },
        {
            title: 'T. Espera',
            key: 'wait_timer',
            align: 'right',
            render: (_, record) => {
                const callTimers = timers[record.id] || { wait: 0, talk: 0 };
                const formatTime = (totalSeconds) => {
                    const hrs = Math.floor(totalSeconds / 3600);
                    const mins = Math.floor((totalSeconds % 3600) / 60);
                    const secs = totalSeconds % 60;
                    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                };
                return <Text strong style={{ fontSize: '13px', color: record.status === 'in_queue' ? '#fa8c16' : '#8c8c8c' }}>{formatTime(callTimers.wait)}</Text>;
            }
        },
        {
            title: 'T. Hablado',
            key: 'talk_timer',
            align: 'right',
            render: (_, record) => {
                const callTimers = timers[record.id] || { wait: 0, talk: 0 };
                const formatTime = (totalSeconds) => {
                    const hrs = Math.floor(totalSeconds / 3600);
                    const mins = Math.floor((totalSeconds % 3600) / 60);
                    const secs = totalSeconds % 60;
                    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                };
                if (record.status === 'in_queue') return <Text type="secondary">-</Text>;
                return <Text strong style={{ fontSize: '13px', color: '#52c41a' }}>{formatTime(callTimers.talk)}</Text>;
            }
        }
    ];

    return (
        <Table
            size="small"
            dataSource={calls}
            columns={columns}
            rowKey="id"
            pagination={false}
            className="queue-monitoring-table"
            style={{ marginTop: 12 }}
            locale={{ emptyText: 'No hay llamadas en cola o activas' }}
        />
    );
};

export default QueueMonitoringTable;
